<template lang="pug">
.registration-error
	VueFeedback(type="error")
		template(slot="feedback-title") Hoppá!
		template(slot="feedback-content")
			p.sf-text Sajnos jelenleg nem tudsz regisztrálni a mi hibánkból, de már dolgozunk rajta.
				br
				| Kérjük, nézz vissza később!
		VueButton(slot="feedback-action", @click="$emit('retry')", button-type="link") Újra megpróbálom
</template>

<script>
import VueFeedback from '@ui-common/vue-feedback';
import VueButton from '@ui-common/vue-button';
export default {
	components: {
		VueFeedback,
		VueButton
	}
};
</script>
